import {
  AfterViewInit,
  Component,
  computed,
  DestroyRef,
  EnvironmentInjector,
  inject,
  Input,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import {
  PoIconModule,
  PoLoadingModule,
  PoPopoverComponent,
  PoPopoverModule,
  PoTooltipModule,
} from '@po-ui/ng-components';
import { Mihmado } from '@recriar/mihmo-interfaces';
import { CommonModule } from '@angular/common';
import { ChatStore } from '../../store/chat.store';
import { ChatModule } from '../../chat.module';
import { ChatCustomerSelectedComponent } from '../../components/chat-customer-selected/chat-customer-selected.component';

@Component({
  selector: 'mihmo-chat-icon-container',
  templateUrl: './chat-icon-container.component.html',
  styleUrls: ['./chat-icon-container.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    PoIconModule,
    PoPopoverModule,
    PoLoadingModule,
    ChatModule,
    PoTooltipModule,
  ],
})
export class ChatIconContainerComponent implements AfterViewInit, OnDestroy {
  @ViewChild('popover') popover: PoPopoverComponent;
  @ViewChild(ChatCustomerSelectedComponent, { static: true })
  chatCustomerSelected: ChatCustomerSelectedComponent;

  _mihmadoSelected = null;
  changed = false;

  @Input()
  set mihmadoSelected(value: Mihmado) {
    this._mihmadoSelected = value;
  }

  get mihmadoSelected() {
    return this._mihmadoSelected;
  }

  private popoverOpened = false;
  openedFirstTime = false;
  private chatStore = inject(ChatStore);
  private destroyRef = inject(DestroyRef);
  environmentInjector = inject(EnvironmentInjector);

  chatComponent: any = null;
  chatLoaded = false; // aqui, controla se o chat já foi carregado!

  readonly isLoadingMessages = computed(
    () => this.chatStore.isLoadingMessages()[this.mihmadoSelected?.id] ?? true,
  );

  readonly unread = computed(
    () =>
      this.chatStore.unreadMessages()[this.mihmadoSelected?.id] ?? {
        conversation: null,
        count: 0,
      },
  );

  ngOnDestroy() {
    this.chatStore.reset();
  }

  async ngAfterViewInit(): Promise<void> {
    const popoverElement =
      this.popover['popoverElement']?.nativeElement || document;

    const observer = new MutationObserver(() => {
      const hasHiddenAttribute = popoverElement.hasAttribute('hidden');

      if (!hasHiddenAttribute && !this.popoverOpened) {
        this.popoverOpened = true;
        this.chatStore.setPopoverOpened(this.mihmadoSelected.id, true);

        if (
          this.unread().conversation &&
          this.unread().conversation?.lastMessage?.index
        ) {
          this.unread().conversation.updateLastReadMessageIndex(
            this.unread().conversation.lastMessage.index,
          );
          this.chatStore.setUnreadCounter(
            this.mihmadoSelected.id,
            0,
            this.unread().conversation,
          );
        }
      } else if (hasHiddenAttribute && this.popoverOpened) {
        this.chatStore.setPopoverOpened(this.mihmadoSelected.id, false);
        this.popoverOpened = false;
      }
    });

    observer.observe(popoverElement, {
      attributes: true,
      attributeFilter: ['hidden'],
    });
  }
}
